import
  styled
from 'styled-components';

export const MainContainer = styled.div`
display: flex;
flex-direction: column;
align-items: center;
gap: var(--24px, 24px);
width: 406px;

@media screen and (max-width:480px) {
  width: 100%;
  height: 100%;
  padding: 0px 16px;
}
`;

export const SubmitTc = styled.label`
  display: block;
  font-family: "RobotoRegular";
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #4a4a4a;
`;

export const SubmitTcSpan = styled.label`
  font-family: "RobotoRegular";
  color: #e60000;
  cursor: pointer;
`;


export const MobileViewLogo = styled.div`
display: none;

@media screen and (max-width:768px) {
  display: block;
}
`